import { SupportedLanguages } from '@/i18n/config'
import { Post } from '@/types/schema/api/radar-search-post'
import { Potential } from '@/utils/detail/potential'

const mockPost1: Post = {
  is_disable_like: false,
  post_id: 'C-vGo6JPGI3',
  crawled_id: '306886581',
  post_type: 'short',
  publish_time: '2024-08-16T15:36:10Z',
  platform_type: 3,
  like_count: 50281,
  share_count: 0,
  view_count: 1163713,
  play_count: 1163713,
  repost_and_quote_count: 0,
  comment_count: 161,
  url: 'https://www.instagram.com/p/C-vGo6JPGI3',
  is_video: true,
  is_live: false,
  is_short: true,
  title: '',
  message:
    '歐！！！買！！！尬！！！！！\n申東熙⋯⋯再次給我飯撒 ‧̫🚰\n比超級久！！！！！！！！',
  text: '歐！！！買！！！尬！！！！！\n申東熙⋯⋯再次給我飯撒 ‧̫🚰\n比超級久！！！！！！！！',
  thumbnail: 'https://thumbnail.kolr.ai/instagram-post/3435994240197091895',
  is_advertorial: false,
  is_collection_post: false,
  kol_uuid: 'a8eac684-47a2-40bd-8ffa-d8ab74656b63',
  kol_name: '派派',
  kol_customized_tags_names: [
    'Art and Entertainment',
    'Daily Topics',
    'Food',
    'Life Style',
    'Media Entertainment/Drama',
    'Media Entertainment/Pop Music',
  ],
  kol_is_radar_star: false,
  kol_is_verified: false,
  customized_tags_names: ['Daily Topics'],
  follower_count: 49699,
  engagement_count: 50442,
  kol_potential: Potential['Normal'],
  ig_post_id: '3435994240197091895',
}

export const makePostContent1 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Hosting a small dessert party at home, sharing homemade treats with family and friends, and feeling happiness in the laughter.'

    case SupportedLanguages.ja:
      return '自宅で小さなスイーツパーティーを開き、家族や友人と手作りのお菓子を分かち合い、笑い声の中で幸せを感じる。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '在家裡舉辦小小的甜點派對，和家人朋友分享手工製作的美點，歡笑聲中感受幸福。'
  }
}

export const makePostContent2 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'This restaurant has a unique interior design and an amazing atmosphere, making guests feel truly welcomed.'
    case SupportedLanguages.ja:
      return 'このレストランは独特な内装と素晴らしい雰囲気があり、まるで自宅にいるかのような心地よさを感じる。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '這間餐廳有著獨特的裝潢，氛圍極佳，讓人有賓至如歸的感覺。'
  }
}

export const makePostContent3 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'On this food journey, I savored the original flavors of fresh ingredients behind each dish—every bite was a natural delight.'
    case SupportedLanguages.ja:
      return '今回のグルメ旅では、一皿一皿に込められた新鮮な食材の本来の味を堪能し、ひと口ごとに自然の驚きを感じた。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '這次的美食之旅，深入品味每一道菜背後新鮮食材的原始風味，每一口都是自然的驚喜。'
  }
}

export const makePostContent4 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Perfect as a gift for friends! Every bite is filled with the chef’s dedication, showcasing exquisite culinary craftsmanship.'
    case SupportedLanguages.ja:
      return 'プレゼントにぴったり！一口食べるごとにシェフのこだわりを感じ、料理の職人技に感動する。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '太適合當作禮物送出給朋友了，每一口都充滿著主廚的用心，感受到料理的精湛技藝。'
  }
}

export const makePostContent5 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Not only does the food taste amazing, but the plating is also beautifully crafted—each dish is a work of art.'
    case SupportedLanguages.ja:
      return '料理が美味しいだけでなく、盛り付けも美しく、一皿一皿がまるでアートのよう。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '菜品不僅美味，擺盤也非常精美，每一道菜都是藝術品。'
  }
}

export const makePostContent6 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Sunlight streams through the window as I leisurely sip a rich coffee, paired with a soft dessert—such a simple yet perfect afternoon tea moment.'
    case SupportedLanguages.ja:
      return '窓から差し込む陽の光の中で、芳醇なコーヒーを一口、ふわふわのスイーツとともに楽しむ、シンプルで贅沢な午後のティータイム。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '陽光灑在窗外，悠閒地品味一口香醇咖啡，搭配著柔軟的甜點，簡單的下午茶時光。'
  }
}

export const makePostContent7 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'A delicious dessert in the studio makes work time even more fulfilling and enjoyable.'
    case SupportedLanguages.ja:
      return 'スタジオで美味しいスイーツを楽しむことで、仕事の時間がより充実し、楽しくなる。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '在工作室裡，擁有一份美味的甜點，讓工作時光更加充實而美好。'
  }
}

export const makePostContent8 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Refreshing coconut ice cream—experience the tropical flavors in every bite!'
    case SupportedLanguages.ja:
      return '爽やかなココナッツアイスクリーム、南国気分を味わえる至福のひととき。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '清爽的椰子冰淇淋，帶你體驗熱帶風情。'
  }
}

export const makePostContent9 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Sitting quietly by the window, listening to the rain, savoring a dessert—this is the best comfort for the soul.'
    case SupportedLanguages.ja:
      return '窓辺に静かに座り、雨音を聴きながらスイーツを一口ずつ味わう。これこそが心を癒す最高のひととき。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '靜靜地坐在窗邊，聽著雨聲，一口一口品味著甜點，這是最好的心靈慰藉。'
  }
}

export const makePostContent10 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Wandering through a small alley, I discovered a hidden dessert shop—every bite was an exciting taste adventure.'
    case SupportedLanguages.ja:
      return '路地裏を歩きながら偶然見つけた隠れ家的なスイーツショップ。ひと口ごとに驚きと感動が広がる美食の冒険。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '走進街角小巷，發現了一家隱藏的甜品店，每一口都是驚奇的味覺冒險。'
  }
}

export const makePostContent11 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Morning sunlight, a cup of coffee, and a soft dessert—a perfect way to start the day!'
    case SupportedLanguages.ja:
      return '朝の陽ざしの中で、一杯のコーヒーとふわふわのスイーツ。素敵な一日のスタートにぴったり！'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '早晨的陽光，一杯咖啡搭配著柔軟的甜點，為一天帶來美好的開始。'
  }
}

export const makeCollaborativeItem1 = (locale?: SupportedLanguages): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'Post'
    case SupportedLanguages.ja:
      return '投稿'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '貼文'
  }
}

export { mockPost1 }
